import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../theme';

export default StyleSheet.create({
  value: {
    fontFamily: textStyles.bold,
    fontSize: 10,
    color: colorPalette.whiteGrey0,
    backgroundColor: colorPalette.primary,
    paddingHorizontal: 6,
    marginRight: 4,
    borderRadius: 1000,
  },
});
